<div class="modal-header">
    <h4 class="modal-title">Access Restricted Notice!</h4>
</div>
<div class="modal-body">
    <div class="user-block-body">
        <p>
            {{message.userblockedMessage}}
        </p>
    </div>
</div>
<div class="modal-footer text-center">
  <button type="button" class="btn btn-accept" (click)="CloseBlockedUserModal()">{{labels.ok}}</button>
</div>
